module.exports = __webpack_public_path__ + "static/media/Newsletter-sample-image.8ed7d67a.svg";